import { LinkingOptions } from '@react-navigation/native'
import { GlobalNavigationParamList } from '../navigationTypes'

export const linkingConfig: LinkingOptions<GlobalNavigationParamList> = {
  prefixes: [
    'http://localhost:5173',
    'https://keeptouch.co',
    'keeptouch://',
    'chrome-extension://',
    'moz-extension://',
  ],
  config: {
    screens: {
      // Root level screens
      Auth: {
        screens: {
          Welcome: 'auth/welcome',
          Register: 'auth/register',
          Login: 'auth/login',
          ForgotPassword: 'auth/forgot-password',
          ResetPassword: 'auth/reset-password',
          RegistrationSteps: 'auth/onboarding',
          FinalStep: 'auth/congrats',
        },
      },
      Tab: {
        screens: {
          ListContacts: 'contacts',
          ListMessages: 'messages',
          Notifications: 'notifications',
          Chatbot: 'chatbot',
        },
      },
      Contacts: {
        screens: {
          AddContact: 'contacts/add',
          CardScanner: 'card-scanner',
          ImportContacts: 'contacts/import',
          AddScannedContact: 'add-scanned-contact',
          DetailsGhostProfile: 'contact',
          ListingContactsFilters: 'contacts/filters',
          //Conversation: 'contact-conversation',
        },
      },
      Messages: {
        screens: {
          AddConversation: 'add-conversation',
          Conversation: 'conversation/:conversationId',
          GroupConversation: 'group-conversation/:conversationId',
        },
      },
      Profile: {
        screens: {
          ProfileHome: 'my-profile',
          ProfileEdit: 'my-profile/edit',
          ProfileMemories: 'my-profile/memories',
          ProfileAddMemory: 'memories/add',
          ProfileShowMemory: 'memories/:memoryId',
          ProfileAlbumMemories: 'albums/:albumId',
          ProfileLivingPlaces: 'my-profile/living-places',
          DetailsGhostProfile: 'profile/:profileId',
          AddGhostContact: 'profile/new',
          EditGhostContact: 'profile/:profileId/edit',
          ProfileContextes: 'profile/:profileId/contextes',
        },
      },
      Menu: {
        screens: {
          ImportContacts: 'import-contacts',
          ClassifyContacts: 'classify-contacts',
          MergeContacts: 'merge-contacts',
          Map: 'map',
          Graph: 'graph',
          Nearby: 'nearby',
          Notes: {
            screens: {
              NotesList: 'notes',
              AddNote: 'note/add',
              EditNote: 'note/edit',
              SelectNoteRecipient: 'note/select-contact',
            },
          },
          Categories: {
            screens: {
              CategoriesList: 'categories',
              CategoryDetails: 'category',
              AddCategory: 'category/add',
              EditCategory: 'category/edit',
            },
          },
          Hashtags: {
            screens: {
              HashtagsList: 'hashtags',
              AddHashtag: 'hashtag/add',
              EditHashtag: 'hashtag/edit',
            },
          },
          RelationalColors: {
            screens: {
              RelationalColorsList: 'relational-colors',
              EditRelationalColor: 'relational-color/edit',
            },
          },
          Calendar: {
            screens: {
              CalendarMain: 'calendar',
              AddEvent: 'calendar/add',
              EditEvent: 'calendar/edit',
            },
          },
          Birthdays: 'birthdays',
          KeepContact: {
            screens: {
              KeepContactMain: 'keep-contacts',
              AddKeepContact: 'keep-contact/add',
              EditKeepContact: 'keep-contact/edit',
            },
          },
          ScheduledMessages: {
            screens: {
              ScheduledMessagesList: 'scheduled-messages',
              AddScheduledMessage: 'scheduled-message/add',
              EditScheduledMessage: 'scheduled-message/edit',
            },
          },
          QRCode: 'qr-code',
          Settings: 'settings',
          Subscription: 'subscription',
          LegalNotice: 'legal-notice',
          ContactUs: 'contact-us',
          PrivacyPolicy: 'privacy-policy',
          JoinUs: 'join-us',
        },
      },
      Extension: 'extension/:profileId/:payload',
    },
  },
}
